module.exports = __webpack_public_path__ + "img/show27.be81adf7.png";